module.exports = __webpack_public_path__ + "media/images/icon__compete-625c04d8460b6a29047822b5ae253c87.png";